<template>
    <div>
        <audio :src="$store.getters.currentAudioSrc" ref="audio" :autoplay="true" :loop="$store.state.a.isAudioLoopPlay"
               @ended="overAudio"
               @pause="onPause"
               @play="onPlay"
        ></audio>
        <button id="playWordButton" class="tool-button":class="isPlaying ? 'imgrotate-common' : ''" @click="handlePlay()"></button>
    </div>
</template>

<script>
    export default {
        name: "AudioTool",
        data() {
            return {
                isPlaying: false,
            }
        },
        methods:{
            handlePlay(row) {
                if(this.$refs.audio.paused){
                    this.$refs.audio.play();
                }else{
                    this.$refs.audio.pause();
                }
            },
            getpaused(){
                if(this.$refs.audio.paused){
                    return false;
                }else{
                    return true;
                }
            },
            // 当音频播放
            onPlay () {
                // console.log('开始播放声音');
                this.isPlaying=true;
            },
            // 当音频暂停
            onPause () {
                // console.log('暂停播放声音');
                this.isPlaying=false;
            },
            //播放完毕执行
            overAudio(){
                // console.log('播放声音完毕');
                this.isPlaying=false;
                // this.audioArr.forEach(item=>{
                //     item.isStart = true;
                // })
            },
        }
    }
</script>

<style scoped>
    .imgrotate-common{
        -webkit-animation:changeright 6s linear infinite;
        border-radius:25px;
    }
    @-webkit-keyframes changeright {

        0% {
            -webkit-transform: rotate(0deg);
        }

        50% {
            -webkit-transform: rotate(180deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
        }
    }
    .tool-button{
        position: relative;
        /*background-color: rgb(131,175,155);*/
        background-color: #B3C0D1;
        cursor: pointer;
        top: 3px;
        left: 0px;
        float: left;
        width: 40px;
        height: 40px;
        height: 40px;
        /*clear: right;*/
        margin-top: 0px;
        margin-right: 3px;
        background-size: 40px 40px;
        /*background-repeat: no-repeat;*/
        /*background-repeat: no-repeat;*/
        background-size: 40px 40px;
        border: 0px;
    }
    #playWordButton{
        background-image: url("../../../../assets/img/learnenglish/play.svg");
    }
</style>